import { SettingsOptions } from "@/shared/types/common";

export const COLORS = {
	"Link 0": "var(--background)",
	"Link 1": "#905156",
	"Link 2": "#908356",
	"Link 3": "#6e9456",
	"Link 4": "#4d6299",
	"Clear Link Selection": null,
};

export type PanelMode = "Justify mode" | "Freeze mode";
const PANEL_NAMES: PanelMode[] = ["Justify mode", "Freeze mode"];
export const DEFAULT_PANEL_MODE = PANEL_NAMES[0];

export interface SubItem {
	id: string;
	text: string;
	color?: string | null;
}

interface MenuItems {
	id: SettingsOptions;
	text: string;
	subItems?: SubItem[];
}

export const menuItems: MenuItems[] = [
	{
		id: SettingsOptions.LINK,
		text: "Link",
		subItems: Object.entries(COLORS).map(([link, color]) => ({
			id: link,
			text: link,
			color,
		})),
	},
	{ id: SettingsOptions.GROUPING, text: "Enable grouping" },
	{ id: SettingsOptions.FILTERING, text: "Value Filtering" },
	{ id: SettingsOptions.CLICK_TRIGGER, text: "One-click trigger" },
	{ id: SettingsOptions.MASTER_DETAIL, text: "Ticker Master detail" },
	{ id: SettingsOptions.CHART_ON_HOVER, text: "Chart on hover" },
	{ id: SettingsOptions.DENSE_MODE, text: "Dense Mode" },
	{
		id: SettingsOptions.PANEL_MODE,
		text: "Panel Mode",
		subItems: PANEL_NAMES.map((mode) => ({
			id: mode,
			text: mode,
		})),
	},
	{
		id: SettingsOptions.DOWNLOAD_CSV,
		text: "Download CSV",
	},
];
